import React, { createContext, useContext, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const RecaptchaContext = createContext(null);

export const RecaptchaProvider = ({ children }) => {
  const recaptchaRef = useRef(null);

  const executeRecaptcha = async () => {
    if (!recaptchaRef.current) {
      throw new Error('reCAPTCHA not loaded');
    }
    const token = await recaptchaRef.current.executeAsync();
    recaptchaRef.current.reset();
    return token;
  };

  return (
    <RecaptchaContext.Provider value={{ executeRecaptcha }}>
      {children}
      <ReCAPTCHA
        sitekey="6LdSkzssAAAAAA0l66H-Od87My9O0zI62t8Np8w3"
        size="invisible"
        ref={recaptchaRef}
        asyncScriptOnLoad={() => console.log('✅ reCAPTCHA script loaded')}
        onErrored={() => console.error('❌ reCAPTCHA failed to load')}
        onExpired={() => console.warn('⚠️ reCAPTCHA expired')}
      />
    </RecaptchaContext.Provider>
  );
};

export const useRecaptcha = () => {
  const context = useContext(RecaptchaContext);
  if (!context) {
    throw new Error('useRecaptcha must be used within RecaptchaProvider');
  }
  return context;
};

